import { createFileRoute } from "@tanstack/react-router";
import { EmailAdmin } from "@/components/admin/email-panels";

export const Route = createFileRoute("/_authenticated/admin/email")({
  component: EmailAdmin,
});
